export const STAT_CODE = {
    COST_TIME: {
        code: 'COST_TIME',
        name: '累计时长'
    },
    READING_TIME: {
        code: 'READING_TIME',
        name: '阅读时长'
    },
    READING_PROGRESS: {
        code: 'READING_PROGRESS',
        name: '阅读进度'
    },
    VIDEO_TIME: {
        code: 'VIDEO_TIME',
        name: '视频时长'
    },
    EXERCISE_COUNT: {
        code: 'EXERCISE_COUNT',
        name: '练习题次'
    },
    EXERCISE_SCORE: {
        code: 'EXERCISE_SCORE',
        name: '练习正确率'
    },
    MAX_DAY_COST_TIME: {
        code: 'MAX_DAY_COST_TIME',
        name: '最长单日学习时间'
    },
    EXTENDED_COUNT: {
        code: 'EXTENDED_COUNT',
        name: '拓展学习'
    },
    NOTES_COUNT: {
        code: 'NOTES_COUNT',
        name: '笔记条数'
    },
    HIGHTLIGHT_COUNT: {
        code: 'HIGHTLIGHT_COUNT',
        name: '高亮条数'
    },
    THREAD_COUNT: {
        code: 'THREAD_COUNT',
        name: '发起讨论次数'
    },
    COMMENT_COUNT: {
        code: 'COMMENT_COUNT',
        name: '参与讨论次数'
    },
}

export const DRILL_TYPE = {
	'100': {
		label: '选择题'
	},
	'200': {
		label: '填空题'
	},
	'300': {
		label: '简答题'
	},
	'400': {
		label: '对话题'
	},
	'500': {
		label: '复诵题'
	},
	'600': {
		label: '理解题'
	},
	'700': {
		label: '排序题'
	}
}

export const SUB_DRILL_TYPE = {
	'101': {
		label: '单项选择'
	},
	'102': {
		label: '多项选择'
	},
	'103': {
		label: '判断'
	},
	'201': {
		label: '看文字填空'
	},
	'202': {
		label: '听录音填空'
	},
	'301': {
		label: '简答'
	},
	'302': {
		label: '翻译'
	},
	'401': {
		label: '对话题'
	},
    '403': {
		label: '课文录音'
	},
	'501': {
		label: '看文字朗读'
	},
	'502': {
		label: '听录音复诵'
	},
	'503': {
		label: '口译'
	},
	'601': {
		label: '阅读理解题'
	},
	'602': {
		label: '听力理解题'
	},
	'701': {
		label: '排序题'
	}
}

export const SECTION_TYPE = {
	'0': {
		value: 0,
		label: '课时练习'
	},
	'1': {
		value: 1,
		label: '扩展阅读'
	},
	'2': {
		value: 2,
		label: '扩展视频'
	},
	'3': {
		value: 3,
		label: '英文对话'
	},
	'4': {
		value: 4,
		label: '英文短句'
	}
}

export const testFList = [
                                {
                                    "id": 27,
                                    "type": 7,
                                    "mediaUrl": "http://kcdbbgawl.np/lwyt",
                                    "summary": "sint ut Ut tempor enim",
                                    "required": false,
                                    "title": "又动由平条支",
                                    "knowledge": {
                                        "name": "口别元党",
                                        "id": 28
                                    }
                                },
                                {
                                    "mediaUrl": "http://uvfgvsvee.bs/dblfjwl",
                                    "required": false,
                                    "knowledge": {
                                        "name": "题来际务",
                                        "id": 57
                                    },
                                    "title": "节设厂可子",
                                    "type": 13,
                                    "summary": "officia",
                                    "id": 55
                                },
                                {
                                    "title": "消精专资",
                                    "id": 42,
                                    "mediaUrl": "http://uwucubvdgf.museum/ytuldpd",
                                    "knowledge": {
                                        "id": 82,
                                        "name": "都统也美感满"
                                    },
                                    "required": false,
                                    "type": 47,
                                    "summary": "eu in tempor ullamco nisi"
                                },
                                {
                                    "title": "点起别前林决",
                                    "summary": "cillum ut aliqua",
                                    "required": true,
                                    "mediaUrl": "http://cwr.it/juzarmgvd",
                                    "id": 84,
                                    "type": 8,
                                    "knowledge": {
                                        "name": "酸队务件",
                                        "id": 97
                                    }
                                },
                                {
                                    "title": "本品持青",
                                    "mediaUrl": "http://biuww.ve/zegx",
                                    "required": false,
                                    "summary": "id sint anim",
                                    "knowledge": {
                                        "name": "天步斯",
                                        "id": 19
                                    },
                                    "type": 77,
                                    "id": 15
                                }
                            ]